type BuildLoadProps = Partial<{
  className: string;
  fill: string;
}>;

export const BuildLoad = ({
  className,
  fill = "#FFF",
}: BuildLoadProps): React.ReactElement => {
  return (
    <svg
      id="dashboard-off"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 110.289 110.292"
      fill={fill}
    >
      <g id="menu" transform="translate(0)">
        <g id="Menu_icon_loads">
          <path
            id="Path_213"
            data-name="Path 213"
            d="M43.115,41.109H10.938v63.249l94.418-63.249H73.208V63.961a3.967,3.967,0,0,1-3.967,3.967H47.082a3.967,3.967,0,0,1-3.967-3.967Zm0-7.928v-.962a3.967,3.967,0,0,1,.172-1.145L49.709,9.94H24.8L13.348,33.187ZM57.637,9.934a3.95,3.95,0,0,1-.143,1.649L51.043,32.8V59.994H65.279V32.8L58.828,11.577a3.95,3.95,0,0,1-.143-1.649Zm8.982,0,6.423,21.135a3.968,3.968,0,0,1,.172,1.145v.962H102.98L91.532,9.928Zm46.671,27.42v70.971a3.967,3.967,0,0,1-3.967,3.967H6.971A3.967,3.967,0,0,1,3,108.325V37.331a3.938,3.938,0,0,1,.406-1.941L18.774,4.215A3.967,3.967,0,0,1,22.329,2H93.964a3.967,3.967,0,0,1,3.555,2.215L112.878,35.4a3.933,3.933,0,0,1,.406,1.958Z"
            transform="translate(-2.999 -2)"
          />
        </g>
      </g>
    </svg>
  );
};
